const locale = {
  title: "Categorías",
  addCategory: "Agregar categoría",
  search: {
    placeholder: "Buscar por categoría",
    removeAll: "Eliminar categorías",
    selectAll: "Seleccionar todo",
    deselectAll: "Deseleccionar todo",
  },
  confirmationDelete: {
    title: "Eliminar categoría",
    description:
      "¿Está seguro de que desea eliminar esta categoría? Los productos se moverán a <strong>“Otras categorías”</strong>.",
    buttonConfirm: "Si, eliminar",
    buttonCancel: "No, cancelar",
  },
  saveChanges: {
    title: "Cambios no guardados",
    description:
      "¿Seguro que deseas abandonar este flujo? Si lo haces perderás todos los cambios no guardados.",
    buttonSave: "Guardar y salir",
    buttonExit: "Salir sin guardar",
  },
  copyMessage: "El enlace a tu categoría se ha copiado correctamente",
  validations: {
    nameRequired: "El nombre de la categoría es requerido",
    nameDuplicate: "Ya existe una categoría con ese nombre",
  },
  breadcrumb: {
    root: "Categoría",
    create: "Crear categoría",
    edit: "Editar categoría",
    addProducts: "Agregar productos",
  },
  mapContent: {
    detailLabel: "Detalle",
    InformationLabel: "Información de la categoría",
    productsLabel: "Productos",
  },
  form: {
    emptyState: {
      title: "No tienes productos / servicios creados aún",
      description: "Crea tu primer producto / servicio para poder editar tus categorías.",
      buttonText: "Crear producto",
    },
    detail: {
      title: "Detalle",
      imageLabel: "Multimedia",
      addMultimedia: "Agregar multimedia",
      validateErrorSize: "Peso máximo soportado: {{size}} MB",
      namePlaceholder: "Escribe un nombre",
      nameLabel: "Nombre de la categoría",
      descriptionPlaceholder: "Escribe una descripción",
      descriptionLabel: "Descripción",
    },
    products: {
      title: "Productos",
      edit: "Editar",
      emptyState: {
        description:
          "Actualmente esta categoría no tiene ningún producto/servicio",
        buttonText: "Agregar producto",
      },
      header: {
        title: "Todos los productos",
        searchPlaceholder: "Buscar por producto",
      },
    },
    saveButton: "Guardar",
    deleteButton: "Eliminar",
    loadingDelete: "Eliminando categoría...",
    successDeleteToast: "La categoría ha sido eliminada correctamente",
    successToast: "La categoría ha sido guardada correctamente",
    updatedToast: "La categoría ha sido actualizada correctamente",
    errorToast: "No se puede eliminar la categoría",
    errorSuccessToast: "Ocurrió un error al guardar la categoría",
    errorUpdatedToast: "Ocurrió un error al actualizar la categoría",
    errorProducts: "Debe agregar al menos un producto a la categoría",
    categoryLoading: "Cargando detalle de la categoría"
  },
};

export default locale;
